export const featureFlags = {
  FEATURE_VIEW_CLOSED_REQ_DETAILS: 'FEATURE_VIEW_CLOSED_REQ_DETAILS',
  FEATURE_TECHNICIAN_FEEDBACK: 'FEATURE_TECHNICIAN_FEEDBACK',
  FEATURE_RESET_CART: 'FEATURE_RESET_CART',
  FEATURE_PROMOTION: 'FEATURE_PROMOTION',
};
